export default "__VITE_ASSET__DUOvw5_r__"